import service from "./service"

const consentUploadUrl = async (data) => {
    const {
        dataForUploadUrl,
        file,
        payloadToSaveApplicantProgress,
        pageType,
    } = data
    return service(dataForUploadUrl, file, payloadToSaveApplicantProgress, pageType)
}

export default consentUploadUrl
